import {
  SHOW_ACCOUNT,
  SHOW_ACCOUNTS,
  CREATE_ACCOUNT,
  DELETE_ACCOUNT,
  UPDATE_ACCOUNT,
  UPDATE_ACCOUNT_ERROR,
} from './types';

let initialState = {
  account: {
    title: '',
    short_code: '',
    subtitle: '',
    domain: '',
    total_clicks: 0,
    total_views: 0,
  },
  accounts: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ACCOUNT:
    case UPDATE_ACCOUNT:
      return {
        ...state,
        account: action.payload,
      };
    case UPDATE_ACCOUNT_ERROR:
      return {
        ...state,
        account: state.account,
      };
    case SHOW_ACCOUNTS:
      return {
        ...state,
        accounts: action.payload,
      };
    case DELETE_ACCOUNT:
    case CREATE_ACCOUNT:
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/content/reducer.js